import { useEffect } from 'react';
import { useMe } from '@/queries/me/useMe';
import { useUpdateMe } from '@/queries/me/useUpdateMe';

/**
 * Keeps the user's stored timezone in sync with their browser's, so server-side consumers
 * without a browser (e.g. MCP tools) interpret dates in the same timezone the UI displays.
 */
export const TimezoneSyncEffect = () => {
  const { data: me } = useMe();
  const { mutate: updateMe } = useUpdateMe();
  const user = me?.user;
  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  useEffect(() => {
    // Never overwrite the impersonated user's timezone with the impersonator's browser.
    if (!user || me?.isImpersonating || !browserTimezone || user.timezone === browserTimezone)
      return;
    updateMe({ timezone: browserTimezone });
  }, [user, me?.isImpersonating, browserTimezone, updateMe]);

  return null;
};
